import { AffectedTrain } from "features/CenterContent/RoleContent/Vaktleder/types";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ScrollableDialogBody } from "shared/components/ScrollableBody";
import {
  ButtonGroup,
  ChoiceChip,
  ChoiceChipGroup,
  DialogFooter,
  DialogRoot,
  DropsButton,
  DropsDialogContent,
  DropsDialogHeader,
  Flex,
  VStack,
} from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";

type CloseTrainsModalProps = {
  closeTrains: () => void;
  selectedTrainIds: AffectedTrain[];
  setSelectedTrainIds: (affectedTrain: AffectedTrain[]) => void;
  closeModal: () => void;
};

export const CloseTrainsModal: FC<CloseTrainsModalProps> = ({
  closeTrains,
  selectedTrainIds,
  setSelectedTrainIds,
  closeModal,
}) => {
  const { t } = useTranslation();
  return (
    <DialogRoot open onOpenChange={closeModal} size="lg" placement="center">
      <DropsDialogContent>
        <DropsDialogHeader>{t("Friskmeld tog")}</DropsDialogHeader>
        <ScrollableDialogBody>
          <VStack alignItems="start" gap="18px">
            <Text>
              {t("Er du sikker på at du vil friskmelde følgende tog?")}
            </Text>
            <Flex alignItems="start" flexWrap="wrap" gap="6px">
              {selectedTrainIds.map((trainId) => {
                const chipValue = `${trainId.trainId.identifier}_${trainId.trainId.nominalDate}`;
                return (
                  <ChoiceChipGroup
                    key={chipValue}
                    size="sm"
                    defaultValue={chipValue}
                  >
                    <ChoiceChip
                      value={chipValue}
                      onClick={() => {
                        const newSelectedTrainIds = selectedTrainIds.filter(
                          (it) => it !== trainId,
                        );
                        setSelectedTrainIds(newSelectedTrainIds);
                        if (newSelectedTrainIds.length === 0) closeModal();
                      }}
                      style={{
                        pointerEvents: "auto",
                      }}
                    >
                      {trainId.trainId.identifier}
                    </ChoiceChip>
                  </ChoiceChipGroup>
                );
              })}
            </Flex>
          </VStack>
        </ScrollableDialogBody>
        <DialogFooter flexDir="column">
          <ButtonGroup mt="12px" w="full" justifyContent="space-between">
            <DropsButton type="button" variant="tertiary" onClick={closeModal}>
              {t("Avbryt")}
            </DropsButton>
            <DropsButton
              onClick={() => {
                closeTrains();
                closeModal();
              }}
              variant="primary"
            >
              {t("Friskmeld tog")}
            </DropsButton>
          </ButtonGroup>
        </DialogFooter>
      </DropsDialogContent>
    </DialogRoot>
  );
};
